import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedCustomerTicketFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/customer_ticket/applied_customer_ticket"]

  removeFilter: (value) ->
    @searchQuery.resetField('with_customer_tickets')

  getFilterValue: ->
    @searchQuery.get('with_customer_tickets')